import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Injectable } from '@angular/core';

import { EditMarkData } from '../models/edit-mark-data';
import { EditType } from '../models/types';
import { EditMarkComponent } from '../modules/progress/components/edit-competitor/edit-mark/edit-mark.component';

@Injectable({
  providedIn: 'root',
})
export class EditMarkService {
  constructor(private dialogService: DialogService) {}

  openMarkEditor(
    mark: EditMarkData,
    timeOffset: string | number,
    editType: EditType,
    header: string | undefined,
    hasFinish: boolean
  ): DynamicDialogRef | undefined {
    if (!mark || !timeOffset) return;

    const newMark = Object.assign({}, mark);

    return this.dialogService.open(EditMarkComponent, {
      header: header,
      width: window.innerWidth < 800 ? '100%' : '400px',
      data: {
        mark: newMark,
        timeOffset,
        editType,
        hasFinish,
      },
    });
  }
}
